import { Tooltip } from "antd";
import { memo } from "react";
import "./FailReason.scss";

export type FailReasonProps = {
  reason?: string | null;
};

// Dòng "Lý do: ..." hiện dưới badge trạng thái khi bản ghi thất bại
export const FailReason = memo(({ reason }: FailReasonProps) => {
  if (!reason?.trim()) {
    return null;
  }

  return (
    <Tooltip title={reason} mouseEnterDelay={0.4}>
      <div className="tableFailReason">Lý do: {reason}</div>
    </Tooltip>
  );
});

FailReason.displayName = "FailReason";
